import React from 'react';
import PropTypes from 'prop-types';
import {
  Link,
  TranslationProvider,
} from '@resy/ui-kitchen';

import './FooterCondensed.scss';

const FooterCondensed = ({ $rootScope }) => {
  const date = new Date().getFullYear();
  const hasBottomNavBar = !$rootScope.hideSelectors;

  return (
    <footer className={`FooterCondensed${hasBottomNavBar ? ' FooterCondensed__bottomNavBar' : ''}`}>
      <div className="FooterCondensed__bottom FooterCondensed__col-container">
        <div className="FooterCondensed__col-left FooterCondensed__bottom__copyright">
          &copy;
          {' '}
          {date}
          {' '}
          Resy Network, Inc.
        </div>
        <div className="FooterCondensed__col-right FooterCondensed__bottom__legal">
          <nav>
            <ul>
              <li>
                <TranslationProvider translationKey="privacy_policy">
                  <Link
                    className="FooterCondensed__privacy-policy"
                    variant="footer"
                    href="privacy"
                    target="_blank"
                    tabIndex={1} // eslint-disable-line jsx-a11y/tabindex-no-positive
                  >
                    Privacy Policy
                  </Link>
                </TranslationProvider>
              </li>
              <li>
                <TranslationProvider translationKey="terms_of_service">
                  <Link
                    className="FooterCondensed__terms-of-service"
                    variant="footer"
                    href="terms"
                    tabIndex={1} // eslint-disable-line jsx-a11y/tabindex-no-positive
                  >
                    Terms of Service
                  </Link>
                </TranslationProvider>
              </li>
              <li>
                <TranslationProvider translationKey="cookie_policy">
                  <Link
                    className="FooterCondensed__cookie-policy"
                    variant="footer"
                    tabIndex={1} // eslint-disable-line jsx-a11y/tabindex-no-positive
                    href="cookie-policy"
                  >
                    Cookie Policy
                  </Link>
                </TranslationProvider>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </footer>
  );
};

FooterCondensed.propTypes = {
  $rootScope: PropTypes.shape({
    hideSelectors: PropTypes.bool.isRequired,
  }).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func.isRequired,
  }).isRequired,
};

export default FooterCondensed;
